import { Box, HStack } from '@chakra-ui/react';

import { ROUNDED_ELEMENT_PROPS } from '../../../../utils/styleUtil';
import VariantLineCommonContent from '../display/VariantLineCommonContent';
import OptionParticipant from '../options/OptionParticipant';

const VariantLinePerSession = ({ variant, loggedUser, placesAvailable, placesMax, ...props }) => {
  return (
    <Box bg="brand.background_main" position="relative" {...ROUNDED_ELEMENT_PROPS}>
      <HStack>
        <OptionParticipant
          fieldValue={variant.participant}
          loggedUser={loggedUser}
          placesAvailable={placesAvailable}
          placesMax={placesMax}
          {...props}
        />
      </HStack>

      <VariantLineCommonContent loggedUser={loggedUser} variant={variant} {...props} />
    </Box>
  );
};

export default VariantLinePerSession;
